import React from "react";
import { withOktaAuth } from "@okta/okta-react";
import MainFrame from "./components/MainFrame";
import "./Home.css";
import Header from "./components/Header/Header";

const Home = ({ authState }) => {
  if (!authState.isAuthenticated) {
    return <div>Loading...</div>;
  }

  console.log("Home.js: authState", authState);

  return (
    <div>
      <Header claims={authState.idToken.claims} />
      <MainFrame />
    </div>
  );
};

export default withOktaAuth(Home);
